<template>
  <div class="container-view">
    <Breadcrumbs/>
    <div class="row col-12 container-titles" style="display: flex">
      <transition name="slide">
        <div
          class="offset-10 col-2"
          style="padding-top: 24px; align-items: flex-end"
          v-if="isVisible"
        >
          <q-btn
            data-cy="save-userdata"
            style="width: 100%; margin-left: 0 !important"
            color="primary"
            label="Guardar"
            icon="save"
            @click="emitgeneralSave()"
            :loading="isLoadingButton"
          />
        </div>
      </transition>
    </div>
    <div class="row espacios-card" style="display: flex">
      <div :class="[classTable, 'leftContainer']">
        <Listado
          :requestUser="requestUser"
          @openInfo="openInfo"
          :isopenSideBar="isVisible"
          :showActiveButton="true"
          :title="'Usuarios externos'"
        />
      </div>
      <transition name="slide">
        <div :class="['col-5 rightContainer']" v-if="isVisible">
          <div id="informacion-container">
            <Informacion :dataUser="dataUser" />
          </div>
        </div>
      </transition>
      <q-dialog v-model="showDialogUser" persistent>
        <q-card style="min-width: 550px">
          <q-card-section>
            <div data-cy="title-add-new-user" class="title text-h6">Añadir un nuevo usuario externo</div>
          </q-card-section>
          <transition name="expand">
            <q-card-section class="q-pt-none q-col-gutter-y-sm">
              <div class="title-option">Por favor indique la información del usuario. Los campos marcados con asterisco son obligatorios.</div>
              <div class="row q-col-gutter-md col-12">
                <div class="col-4">
                  <q-input
                    data-cy="external-name"
                    v-model="v$.external.name.$model"
                    outlined
                    :error="v$.external.name.$error"
                    label="*Nombre"
                    class="col-12"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </div>
                <div class="col-8">
                  <q-input
                    data-cy="external-surname"
                    v-model="v$.external.surNames.$model"
                    outlined
                    :error="v$.external.surNames.$error"
                    label="*Apellidos"
                    class="col-12"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </div>
              </div>
              <div class="row q-col-gutter-md col-12">
                <div class="col-12">
                  <q-input
                    data-cy="external-username"
                    v-model="v$.external.username.$model"
                    outlined
                    :error="v$.external.username.$error"
                    label="*Username"
                    class="col-12"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </div>
              </div>
              <div class="row q-col-gutter-md col-12">
                <div data-cy="field-external-entidad" class="col-12">
                  <MultiSelectPredictive
                  :labelBox="{
                    select: 'Entidad'
                  }"
                  labelDataCy="entidad-servicio-multi-select-new"
                  endPoint="EntidadUser"
                  :dataObj="this.idUsuario"
                  relationShip="entidad-relationship"
                  :arraySelected="entidadesSelected"
                  :arrayAll="arrayEntidades"
                  :eventSave="events.saveEntidades"
                  :isMandatory=false
                />
                </div>
              </div>
              <div class="row q-col-gutter-md col-12">
                <div class="col-5">
                  <q-input
                    data-cy="external-phone"
                    v-model="external.phone"
                    outlined
                    label="Teléfono"
                    class="col-12"
                    :rules="[
                      (val) =>
                        !val || validateTfno(val) || 'Teléfono no válido',
                    ]"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </div>
                <div class="col-7">
                  <q-input
                    data-cy="external-email"
                    v-model="v$.external.email.$model"
                    outlined
                    :error="v$.external.email.$error"
                    label="*Email"
                    class="col-12"
                    :rules="[
                      (val) =>
                        validateEmail(val) || 'Correo electrónico no válido',
                    ]"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </div>
              </div>
              <div class="row q-col-gutter-md col-12">
                <div class="col-12">
                  <q-input
                    data-cy="external-create-company"
                    v-model="external.company"
                    :error="v$.external.company.$error"
                    outlined
                    label="*Empresa"
                    class="col-12"
                    :rules="[
                      (val) =>
                        !checkIfFieldEmpty(val) || 'Empresa no válida',
                    ]"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </div>
              </div>
              <div class="row q-col-gutter-md col-12">
                <div class="col-12">
                  <q-select
                    data-cy="locale-add"
                    outlined
                    v-model="external.locale"
                    :options="languages"
                    option-value="id"
                    option-label="name"
                    label="Idiomas"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-select>
                </div>
              </div>
            </q-card-section>
          </transition>
          <q-card-actions align="right" class="text-primary container-actions">
            <q-btn
              flat
              label="Cancelar"
              padding="xs lg"
              v-close-popup
              @click="clearData()"
            />
            <q-btn
              data-cy="create-user"
              label="Añadir"
              color="primary"
              padding="xs lg"
              @click="selectTypeUser()"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
      <q-page-sticky position="bottom-right" :offset="[28, 28]">
        <q-btn
          data-cy="new-user"
          fab
          icon="add"
          title="Crear nuevo usuario externo"
          color="primary"
          @click="_createUser()"
        />
      </q-page-sticky>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Message from '@/components/shared/mixins/Message.js';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Listado from '../components/Listado.vue';
import Informacion from '../components/Informacion.vue';
import { QPageSticky, QDialog } from 'quasar';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import MultiSelectPredictive from '@/shared/multi-select-predictive/MultiSelectPredictive.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  computed: {
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  components: {
    Listado,
    Informacion,
    QPageSticky,
    QDialog,
    Breadcrumbs,
    MultiSelectPredictive
  },
  mixins: [Message, Validation, Loading],
  validations: {
    external: {
      name: { required },
      surNames: { required },
      email: { required },
      username: { required },
      company: { required }
    }
  },
  data: function () {
    return {
      dataUser: {},
      arrayUsuarios: [],
      classTable: 'col-12',
      isVisible: false,
      showDialogUser: false,
      external: {
        name: null,
        surNames: null,
        phone: null,
        company: null,
        email: null,
        username: null,
        locale: { name: 'Español', id: 'es' }
      },
      isLoadingButton: false,
      checkSave: {
        isEntidadesSave: null,
        existError: false,
        isInfoSave: null
      },
      checkSelect: {
        isCorrect: true
      },
      requestUser: {
        list: '/User',
        count: '/User/Count',
        filter: '/User/SearchExternalUsers'
      },
      languages: [{ name: 'Español', id: 'es' }, { name: 'Inglés', id: 'en' }, { name: 'Catalán', id: 'ca' }],
      dataEntidad: {
        id: null,
        entidades: []
      },
      entidadesSelected: [],
      arrayEntidades: [],
      events: {
        saveEntidades: 'GUARDAR_ENTIDADES_NEW'
      },
      idUsuario: {}
    };
  },
  async created () {
    await this.getEntidades();
  },
  async mounted () {
    let idUser = this.$route.params.idUser ? this.$route.params.idUser : null;
    if (idUser) {
      let data = {
        data: {
          id: idUser
        }
      };

      this.openInfo(data);
    }
  },
  methods: {
    async getEntidades () {
      let idUser = this.$store.getters['PF/userId'];
      this.showLoading();
      let request = {
        controller: this.isSuperAdmin ? `/Entidad` : `/Entidad/User/${idUser}`
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.arrayEntidades = response.data;
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    emitgeneralSave () {
      // Reset variables
      this.resetSaved();

      this.$eventHub.$emit('ACTUALIZAR_INFORMACION', {
        callback: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    resetSaved () {
      this.isLoadingButton = true;
      this.checkSave.existError = false;
      this.checkSave.isInfoSave = null;
      this.idUsuario = {};
      this.entidadesSelected = [];
      this.showDialogUser = false;
    },
    checkSaved () {
      if (this.checkSave.isInfoSave) {
        this.showMessage('Datos guardados con éxito.');
        // Stop Loading Button
        this.isLoadingButton = false;

        this.$eventHub.$emit('refreshlistUsers');
      } else if (
        (this.checkSave.isInfoSave === false) &&
        this.checkSave.existError === false
      ) {
        this.checkSave.existError = true;
        this.showError(
          'Ha ocurrido un problema, vuelva a intentarlo más tarde.'
        );
        this.isLoadingButton = false;
      }
      this.isLoadingButton = false;
    },
    clearData () {
      this.external.name = null;
      this.external.surNames = null;
      this.external.phone = null;
      this.external.company = null;
      this.external.email = null;
      this.external.username = null;

      // Reset validation form
      this.v$.external.$reset();
    },
    selectTypeUser () {
      let dataArray = {};

      this.v$.external.$touch();
      if (!this.v$.$error && this.validateEmail(this.external.email) && !this.checkIfFieldEmpty(this.external.company)) {
        dataArray = {
          user: {
            email: this.external.email,
            internal: false,
            enabled: true,
            username: this.external.username,
            name: this.external.name,
            surNames: this.external.surNames,
            attributes: {
              phone: this.external.phone,
              company: this.external.company,
              locale: this.external.locale.id
            }
          }
        };
        this.selectUser(dataArray);
      }
    },
    async saveEntidades (id, response) {
      await this.$eventHub.$emit(this.events.saveEntidades, id, {
        callback: x => {
          this.checkSave.isEntidadesSave = x.status;
          if (this.checkSave.isEntidadesSave) {
            this.showMessage('Usuario externo creado correctamente.');
            this.$eventHub.$emit('refreshlistUsers');
            this.openInfo(response);
            this.closeNewUser();
            this.clearData();
            this.hideLoading();
          } else {
            this.hideLoading();
            this.showError('Error al guardar las entidades del usuario');
          }
        },
        rejected: x => {
          this.checkSave.isEntidadesSave = x.status;
        }
      });
    },
    async selectUser (data) {
      this.showLoading();

      let request = {
        controller: '/User',
        filter: {},
        body: data
      };

      if (this.checkSelect.isCorrect) {
        this.$store
          .dispatch('PF/postSuit', request)
          .then(async (response) => {
            this.idUsuario = { 'id': response.data.id };
            await this.saveEntidades(this.idUsuario, response);
          })
          .catch((err) => {
            this.showError(err.message);
            this.hideLoading();
          });
      } else {
        this.hideLoading();
      }
    },
    _createUser () {
      this.showDialogUser = true;
    },
    closeNewUser () {
      this.showDialogUser = false;
    },
    async openInfo (data) {
      let open = data.open === false ? data.open : true;

      this.showLoading();
      let idUser = data.data.id;

      await this.getInfoUser(idUser);

      this.hideLoading();

      if (!open) return;

      this.classTable = 'slide-right col-7';
      // eslint-disable-next-line no-return-assign
      setTimeout(() => (this.isVisible = true), 1000);
    },
    async getInfoUser (idUser) {
      this.$router.push({ name: 'form_user_edit', params: { idUser: idUser } }).catch(e => {});

      let request = {
        controller: '/User/' + idUser
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.dataUser = response.data;
        })
        .catch((err) => {
          this.showError(err.message);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.espacios-card {
  &:deep() {
    .q-focus-helper {
      background-color: transparent !important;
      &:before {
        background-color: transparent !important;
      }
    }
    .q-card {
      box-shadow: none;
    }
  }
}

.title-option {
  font-size: 15px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.22px;
  color: #888888;
  margin-bottom: 10px;
}

.container-actions {
  padding-top: 8px;
}

.espacios-card {
  margin-top: 30px;
}

.rightContainer {
  padding-left: 32px;
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.slide-right {
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 1s ease-in-out;
  max-height: 500px;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
